import React from "react"
import "./MythBusters.css"

const myths = [
  {
    myth: "“Automation is killing jobs.”",
    truth:
      "Actually, it’s increasing demand for skilled talent — and staffing firms are thriving.",
  },
  {
    myth: "“Franchises cost hundreds of thousands to start.”",
    truth: "Cordova requires just $50K liquid.",
  },
  {
    myth: "“I’m not ready to be an entrepreneur.”",
    truth:
      "The Cordova System gives you support, structure, and training from day one.",
  },
]

const MythBusters = () => {
  return (
    <section className='myth-busters section section-light-gray'>
      <div className='container'>
        <div className='myth-header animate-fade-up'>
          <h2 className='section-title'>Break the Myths Holding You Back</h2>
          <p className='section-subtitle'>
            Shift from outdated assumptions to evidence-backed confidence about
            owning a staffing franchise.
          </p>
        </div>
        <div className='myth-grid'>
          {myths.map((item, index) => (
            <div
              key={item.myth}
              className='myth-card animate-fade-up'
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className='myth-label'>MYTH</div>
              <p className='myth-text'>{item.myth}</p>
              <div className='truth-label'>REALITY</div>
              <p className='truth-text'>{item.truth}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default MythBusters

